import { render, staticRenderFns } from "./buttonTd.vue?vue&type=template&id=2125671b&"
import script from "./buttonTd.vue?vue&type=script&lang=js&"
export * from "./buttonTd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports